// stores/tablePrefilter.ts
import { defineStore } from 'pinia';

export const useTablePrefilterStore = defineStore('tablePrefilterStore', {
  state: (): {
    selectedTabByKey: Record<string, number>;
    selectedOptionIndexByKey: Record<string, number[]>;
  } => ({
    selectedTabByKey: {}, // saves active tabindex related to each dataKey
    selectedOptionIndexByKey: {}, // saves option indexper tab related to each dataKey
  }),

  actions: {
    setSelectedTab(dataKey: string, tabIndex: number) {
      this.selectedTabByKey[dataKey] = tabIndex;
    },

    getSelectedTab(dataKey: string): number {
      return this.selectedTabByKey[dataKey] ?? 0;
    },

    setOptionIndices(dataKey: string, optionIndices: number[]) {
      this.selectedOptionIndexByKey[dataKey] = optionIndices;
    },

    getOptionIndices(dataKey: string): number[] {
      return this.selectedOptionIndexByKey[dataKey] ?? [];
    },
  },

  persist: {
    storage: localStorage,
  },
});
